var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftCardInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.226,0.734 L0.724,31.236 C0.647,31.313 0.682,31.439 0.786,31.455 L0.786,31.455 L4.459,32.032 C4.513,32.04 4.552,32.081 4.56,32.134 L4.56,32.134 L5.107,35.618 C5.116,35.671 5.156,35.711 5.209,35.719 L5.209,35.719 L8.693,36.267 C8.746,36.275 8.787,36.315 8.795,36.367 L8.795,36.367 L9.383,40.112 C9.391,40.166 9.431,40.206 9.484,40.214 L9.484,40.214 L13.228,40.802 C13.281,40.81 13.322,40.85 13.33,40.904 L13.33,40.904 L13.916,44.636 C13.924,44.689 13.964,44.729 14.018,44.737 L14.018,44.737 L17.751,45.323 C17.803,45.331 17.843,45.372 17.852,45.425 L17.852,45.425 L18.428,49.099 C18.445,49.202 18.572,49.237 18.648,49.161 L18.648,49.161 L49.151,18.658 C49.227,18.581 49.192,18.455 49.089,18.439 L49.089,18.439 L45.415,17.862 C45.363,17.854 45.322,17.814 45.313,17.76 L45.313,17.76 L44.727,14.028 C44.719,13.975 44.68,13.934 44.626,13.926 L44.626,13.926 L40.893,13.34 C40.84,13.332 40.8,13.292 40.792,13.238 L40.792,13.238 L40.204,9.494 C40.196,9.441 40.155,9.401 40.102,9.393 L40.102,9.393 L36.358,8.805 C36.305,8.797 36.265,8.756 36.257,8.703 L36.257,8.703 L35.709,5.219 C35.701,5.166 35.661,5.126 35.608,5.118 L35.608,5.118 L32.124,4.57 C32.071,4.562 32.031,4.522 32.023,4.469 L32.023,4.469 L31.445,0.796 C31.435,0.73 31.381,0.692 31.324,0.692 L31.324,0.692 C31.289,0.692 31.254,0.706 31.226,0.734 L31.226,0.734 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.232,0.734 L11.258,3.707 C11.335,3.631 11.461,3.667 11.477,3.77 L11.477,3.77 L12.054,7.443 C12.062,7.495 12.103,7.537 12.156,7.545 L12.156,7.545 L15.639,8.092 C15.692,8.099 15.733,8.141 15.741,8.194 L15.741,8.194 L16.288,11.678 C16.296,11.73 16.338,11.771 16.39,11.779 L16.39,11.779 L20.134,12.367 C20.186,12.375 20.227,12.416 20.236,12.468 L20.236,12.468 L20.823,16.213 C20.831,16.265 20.873,16.307 20.925,16.314 L20.925,16.314 L24.657,16.901 C24.71,16.909 24.751,16.949 24.759,17.002 L24.759,17.002 L25.317,20.339 C25.368,20.637 25.269,20.942 25.056,21.156 L25.056,21.156 L0.836,45.375 C0.847,45.39 0.855,45.406 0.858,45.425 L0.858,45.425 L1.435,49.099 C1.451,49.202 1.577,49.237 1.653,49.161 L1.653,49.161 L32.156,18.658 C32.234,18.581 32.198,18.455 32.095,18.439 L32.095,18.439 L28.421,17.862 C28.41,17.861 28.401,17.856 28.392,17.853 L28.392,17.853 C28.385,17.849 28.377,17.846 28.371,17.84 L28.371,17.84 C28.344,17.822 28.325,17.794 28.32,17.76 L28.32,17.76 L27.734,14.028 C27.725,13.976 27.684,13.934 27.632,13.926 L27.632,13.926 L23.899,13.34 C23.846,13.332 23.806,13.291 23.797,13.238 L23.797,13.238 L23.209,9.494 C23.202,9.442 23.161,9.401 23.108,9.393 L23.108,9.393 L19.364,8.805 C19.311,8.797 19.271,8.755 19.262,8.703 L19.262,8.703 L18.716,5.219 C18.707,5.166 18.666,5.126 18.614,5.118 L18.614,5.118 L15.129,4.57 C15.077,4.562 15.036,4.521 15.027,4.469 L15.027,4.469 L14.451,0.796 C14.441,0.73 14.387,0.692 14.329,0.692 L14.329,0.692 C14.295,0.692 14.26,0.706 14.232,0.734 L14.232,0.734 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.724,6.205 C0.647,6.282 0.682,6.409 0.786,6.425 L0.786,6.425 L4.459,7.002 C4.513,7.01 4.552,7.05 4.56,7.103 L4.56,7.103 L5.107,10.587 C5.116,10.639 5.156,10.68 5.209,10.689 L5.209,10.689 L8.693,11.235 C8.746,11.244 8.787,11.285 8.795,11.337 L8.795,11.337 L9.383,15.082 C9.391,15.134 9.431,15.174 9.484,15.184 L9.484,15.184 L13.228,15.77 C13.281,15.779 13.322,15.82 13.33,15.872 L13.33,15.872 L13.916,19.605 C13.924,19.658 13.964,19.699 14.018,19.707 L14.018,19.707 L17.751,20.293 C17.803,20.301 17.843,20.341 17.852,20.395 L17.852,20.395 L18.428,24.068 C18.445,24.171 18.572,24.207 18.648,24.13 L18.648,24.13 L24.697,18.081 L6.773,0.156 L0.724,6.205 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.836,5.413 C0.841,5.42 0.845,5.426 0.849,5.434 L0.849,5.434 C0.852,5.443 0.856,5.453 0.858,5.464 L0.858,5.464 L1.435,9.137 C1.438,9.163 1.45,9.184 1.464,9.201 L1.464,9.201 C1.48,9.218 1.5,9.229 1.521,9.236 L1.521,9.236 C1.532,9.238 1.544,9.24 1.555,9.24 L1.555,9.24 C1.578,9.24 1.601,9.235 1.623,9.222 L1.623,9.222 C1.634,9.217 1.644,9.209 1.653,9.199 L1.653,9.199 L7.703,3.15 L5.401,0.849 L0.836,5.413 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.874,1.505 C0.761,2.62 0.4,3.935 1.702,5.237 L1.702,5.237 L3.842,7.377 C5.143,8.678 6.459,8.317 7.572,7.203 L7.572,7.203 C8.671,6.104 9.047,4.773 7.746,3.472 L7.746,3.472 L5.606,1.333 C5.028,0.755 4.444,0.507 3.878,0.507 L3.878,0.507 C3.168,0.507 2.485,0.894 1.874,1.505 L1.874,1.505 Z M4.897,6.321 L2.757,4.181 C2.163,3.588 2.236,2.995 2.8,2.432 L2.8,2.432 C3.365,1.867 3.971,1.781 4.564,2.373 L4.564,2.373 L6.705,4.513 C7.298,5.106 7.211,5.714 6.647,6.278 L6.647,6.278 C6.351,6.574 6.047,6.734 5.739,6.734 L5.739,6.734 C5.46,6.734 5.179,6.603 4.897,6.321 L4.897,6.321 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.822,0.581 C0.648,0.755 0.547,1.001 0.648,1.276 L0.648,1.276 L5.97,17.213 C5.999,17.329 6.057,17.415 6.129,17.487 L6.129,17.487 C6.389,17.748 6.896,17.79 7.229,17.458 L7.229,17.458 C7.43,17.256 7.531,16.953 7.445,16.692 L7.445,16.692 L2.167,0.798 C2.123,0.698 2.066,0.611 1.979,0.524 L1.979,0.524 C1.833,0.379 1.649,0.316 1.464,0.316 L1.464,0.316 C1.225,0.316 0.985,0.419 0.822,0.581 L0.822,0.581 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.568,1.967 C0.455,3.081 0.093,4.397 1.395,5.699 L1.395,5.699 L3.536,7.839 C4.837,9.14 6.153,8.779 7.266,7.666 L7.266,7.666 C8.365,6.567 8.742,5.236 7.44,3.934 L7.44,3.934 L5.3,1.794 C4.722,1.216 4.138,0.969 3.572,0.969 L3.572,0.969 C2.863,0.969 2.18,1.357 1.568,1.967 L1.568,1.967 Z M4.592,6.783 L2.451,4.643 C1.858,4.05 1.93,3.457 2.494,2.893 L2.494,2.893 C3.058,2.329 3.665,2.242 4.259,2.836 L4.259,2.836 L6.399,4.975 C6.992,5.569 6.905,6.176 6.341,6.74 L6.341,6.74 C6.045,7.036 5.741,7.196 5.433,7.196 L5.433,7.196 C5.155,7.196 4.873,7.065 4.592,6.783 L4.592,6.783 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.894,0.974 L0.777,6.091 C0.506,6.363 0.506,6.803 0.777,7.075 L0.777,7.075 C0.912,7.211 1.09,7.279 1.269,7.279 L1.269,7.279 C1.447,7.279 1.625,7.211 1.761,7.075 L1.761,7.075 L6.878,1.958 C7.15,1.686 7.15,1.246 6.878,0.974 L6.878,0.974 C6.743,0.838 6.564,0.771 6.386,0.771 L6.386,0.771 C6.208,0.771 6.03,0.838 5.894,0.974 L5.894,0.974 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0.58 L0.384,5.698 C0.111,5.969 0.111,6.409 0.384,6.681 L0.384,6.681 C0.519,6.817 0.698,6.886 0.875,6.886 L0.875,6.886 C1.053,6.886 1.231,6.817 1.367,6.681 L1.367,6.681 L6.485,1.564 C6.757,1.293 6.757,0.852 6.485,0.58 L6.485,0.58 C6.349,0.444 6.171,0.377 5.992,0.377 L5.992,0.377 C5.814,0.377 5.636,0.444 5.5,0.58 L5.5,0.58 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.616,0.695 L0.498,5.813 C0.226,6.084 0.226,6.525 0.498,6.797 L0.498,6.797 C0.634,6.933 0.812,7 0.99,7 L0.99,7 C1.169,7 1.346,6.933 1.482,6.797 L1.482,6.797 L6.599,1.679 C6.871,1.408 6.871,0.966 6.599,0.695 L6.599,0.695 C6.463,0.56 6.285,0.491 6.107,0.491 L6.107,0.491 C5.93,0.491 5.751,0.56 5.616,0.695 L5.616,0.695 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.025,1.137 L0.908,6.254 C0.637,6.526 0.637,6.966 0.908,7.238 L0.908,7.238 C1.045,7.374 1.222,7.442 1.4,7.442 L1.4,7.442 C1.579,7.442 1.757,7.374 1.893,7.238 L1.893,7.238 L7.01,2.121 C7.281,1.849 7.281,1.408 7.01,1.137 L7.01,1.137 C6.874,1.001 6.696,0.934 6.518,0.934 L6.518,0.934 C6.34,0.934 6.161,1.001 6.025,1.137 L6.025,1.137 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.748,0.256 L26.058,4.946 C25.786,5.218 25.786,5.659 26.058,5.93 L26.058,5.93 C26.329,6.202 26.771,6.202 27.042,5.93 L27.042,5.93 L30.946,2.026 L31.349,4.59 C31.404,4.943 31.677,5.217 32.03,5.273 L32.03,5.273 L35.101,5.755 L35.583,8.826 C35.638,9.178 35.912,9.451 36.265,9.506 L36.265,9.506 L39.596,10.029 L40.118,13.36 C40.173,13.713 40.447,13.986 40.8,14.042 L40.8,14.042 L44.119,14.563 L44.64,17.883 C44.696,18.235 44.969,18.51 45.321,18.564 L45.321,18.564 L47.886,18.967 L24.711,42.142 L22.428,39.858 C22.156,39.587 21.715,39.586 21.443,39.858 L21.443,39.858 C21.172,40.13 21.172,40.57 21.443,40.842 L21.443,40.842 L23.727,43.127 L18.957,47.896 L18.553,45.331 C18.498,44.98 18.225,44.706 17.872,44.65 L17.872,44.65 L14.553,44.129 L14.032,40.81 C14.011,40.678 13.96,40.557 13.885,40.453 L13.885,40.453 C13.76,40.283 13.57,40.163 13.351,40.129 L13.351,40.129 L10.02,39.606 L9.496,36.274 C9.441,35.922 9.167,35.648 8.815,35.594 L8.815,35.594 L5.744,35.111 L5.262,32.04 C5.206,31.688 4.933,31.414 4.581,31.359 L4.581,31.359 L2.016,30.956 L6.787,26.185 L17.865,37.264 C18.137,37.536 18.577,37.536 18.849,37.264 L18.849,37.264 C19.121,36.992 19.121,36.551 18.849,36.28 L18.849,36.28 L7.771,25.201 L23.551,9.422 C23.822,9.15 23.822,8.709 23.551,8.437 L23.551,8.437 C23.279,8.166 22.838,8.166 22.567,8.437 L22.567,8.437 L0.246,30.759 C0.023,30.982 -0.056,31.305 0.041,31.603 L0.041,31.603 C0.065,31.677 0.099,31.745 0.14,31.807 L0.14,31.807 C0.266,31.993 0.463,32.121 0.691,32.157 L0.691,32.157 L3.952,32.669 L4.434,35.74 C4.441,35.784 4.451,35.828 4.465,35.868 L4.465,35.868 C4.559,36.158 4.807,36.373 5.116,36.421 L5.116,36.421 L8.186,36.903 L8.709,40.234 C8.717,40.278 8.726,40.321 8.74,40.363 L8.74,40.363 C8.829,40.635 9.055,40.84 9.337,40.903 L9.337,40.903 C9.355,40.907 9.373,40.913 9.391,40.916 L9.391,40.916 L12.721,41.439 L13.243,44.758 C13.298,45.11 13.572,45.384 13.924,45.44 L13.924,45.44 L17.244,45.961 L17.756,49.22 C17.804,49.526 18.016,49.776 18.31,49.872 L18.31,49.872 C18.394,49.899 18.481,49.913 18.566,49.913 L18.566,49.913 C18.783,49.913 18.995,49.827 19.155,49.667 L19.155,49.667 L49.658,19.165 C49.881,18.942 49.958,18.618 49.862,18.32 L49.862,18.32 C49.766,18.026 49.516,17.814 49.211,17.765 L49.211,17.765 L45.95,17.254 L45.429,13.934 C45.374,13.582 45.1,13.309 44.748,13.253 L44.748,13.253 L41.429,12.732 L40.906,9.402 C40.851,9.049 40.577,8.775 40.225,8.719 L40.225,8.719 L36.893,8.197 L36.411,5.125 C36.355,4.773 36.082,4.499 35.73,4.445 L35.73,4.445 L32.658,3.962 L32.147,0.702 C32.099,0.396 31.887,0.147 31.594,0.052 L31.594,0.052 C31.509,0.024 31.423,0.01 31.336,0.01 L31.336,0.01 C31.119,0.01 30.908,0.096 30.748,0.256 L30.748,0.256 Z",
    id: "path-23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hbi_rental_account--",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hbi_webstore_account_billing_information_empty",
    transform: "translate(-570.000000, -765.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(570.000000, 765.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#D4D5D6",
    mask: "url(#mask-2)",
    points: "-4.318 54.202 54.192 54.202 54.192 -4.308 -4.318 -4.308"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(17.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#C9CBCD",
    mask: "url(#mask-4)",
    points: "-4.164 54.202 37.197 54.202 37.197 -4.308 -4.164 -4.308"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#A8AAAD",
    mask: "url(#mask-6)",
    points: "-4.318 29.171 29.697 29.171 29.697 -4.844 -4.318 -4.844"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(17.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#9C9EA1",
    mask: "url(#mask-8)",
    points: "-4.164 14.24 12.703 14.24 12.703 -4.152 -4.164 -4.152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(31.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#424240",
    mask: "url(#mask-10)",
    points: "-4.128 13.207 13.571 13.207 13.571 -4.493 -4.128 -4.493"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(26.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#231F20",
    mask: "url(#mask-12)",
    points: "-4.392 22.695 12.476 22.695 12.476 -4.684 -4.392 -4.684"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(20.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#231F20",
    mask: "url(#mask-14)",
    points: "-4.435 13.669 13.265 13.669 13.265 -4.031 -4.435 -4.031"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(12.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#231F20",
    mask: "url(#mask-16)",
    points: "-4.427 12.279 12.082 12.279 12.082 -4.23 -4.427 -4.23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(16.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#231F20",
    mask: "url(#mask-18)",
    points: "-4.821 11.886 11.688 11.886 11.688 -4.623 -4.821 -4.623"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(23.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#231F20",
    mask: "url(#mask-20)",
    points: "-4.706 12 11.803 12 11.803 -4.509 -4.706 -4.509"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(19.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#231F20",
    mask: "url(#mask-22)",
    points: "-4.295 12.442 12.214 12.442 12.214 -4.067 -4.295 -4.067"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#231F20",
    mask: "url(#mask-24)",
    points: "-5 54.912 54.902 54.912 54.902 -4.99 -5 -4.99"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardInactive);
export default __webpack_public_path__ + "static/media/gift_card_inactive.09dfd2e581b1d56880659d4d75845f3a.svg";
export { ForwardRef as ReactComponent };